import React, { useContext, useEffect, useMemo, useState } from "react";
import { PageContext } from "components/PageProvider";
import { getMenuList } from "pages/menu";
import { Link } from "react-router-dom";

/* 좌측 네비게이션 */
function LeftNav(props) {
	const {gnbId, lnbId, snbId} = useContext(PageContext);
	const [gnbLabel, setGnbLabel] = useState("");
	const menuItems = useMemo(() => [...getMenuList(gnbId)], [gnbId]);

	useEffect(() => {
		if(gnbId != null && gnbId !== "") {
			setGnbLabel(getMenuList().filter(m => m.menuId === gnbId)[0].label);
		}
	}, [gnbId]);

    return (
		<>
			{gnbLabel &&(
			<div className="layout">
				<div className="nav">
					<div className="inner">
						<h2>{gnbLabel}</h2>
						<ul className="menu4">
							{menuItems.map((menuItem) => (
								<li key={menuItem.label}>
									{(!menuItem.hasOwnProperty("subMenus") || menuItem.subMenus?.length === 0) && (
										<Link
											to={menuItem.menuUrl}
											className={`padding-x libg ${lnbId === menuItem.menuId ? 'cur': ''}`}
										>
											{menuItem.label}
										</Link>
									)}
									{menuItem.subMenus?.length > 0 && (
										<Link
											to={menuItem.subMenus[0].menuUrl}
											className={`padding-x ${menuItem.subMenus?.length > 0 ? '' : 'libg'} ${lnbId === menuItem.menuId ? 'cur': ''}`}
										>
											{menuItem.label}
										</Link>
									)}
									{menuItem.subMenus?.length > 0 && (
										<ul className="menu7">
											{menuItem.subMenus.map((subMenu) => (
												<li key={subMenu.label}>
													<Link
														to={subMenu.menuUrl}
														// onClick={(e) => clickHandle( menuItem, subMenu ) }
														// activeName={activeSub === subMenu.id ? subMenu.label : null}
														className={`padding-x libg ${snbId === subMenu.menuId ? 'cur': ''} ${snbId + ' ' + subMenu.menuId}`}
													>
													{subMenu.label}
													</Link>
												</li>
											))}
										</ul>
									)}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		)}
	</>
    );
}

export default LeftNav;
